module.exports = __webpack_public_path__ + "img/ci_google.8da28892.svg";